import * as Yup from "yup";
import { LASTNAME, FIRSTNAME, EMAIL } from "../utils/regex";

export default Yup.object({
  lastName: Yup.string()
    .required("Votre nom est requis")
    .matches(
      LASTNAME,
      "Votre nom doit contenir uniquement des lettres, des acccents et espace",
    ),
  firstName: Yup.string()
    .required("Votre Prénom est requis")
    .matches(
      FIRSTNAME,
      "Votre prénom doit contenir uniquement des lettres, des accents et tirets",
    ),
  email: Yup.string()
    .required("Votre mail est requis")
    .matches(EMAIL, "Veuillez saisir une adresse email valide"),
  testimonialText: Yup.string()
    .required("Le champs avis est requis")
    .max(500, "Votre avis ne peut pas dépasser 500 caractères"),
});
